#!/usr/bin/env node

require(`gatsby-cli`)
